import { Box, Container } from "@mui/material";
import React from "react";
import CustomText from "../../customComponents/customText";
import { translation } from "../../assets/translation";
import { language } from "../../assets/function";
import { Colors } from "../../assets/colors";
import { motion } from "framer-motion";
function CoreFeatures() {
  let staticText = translation[language];
  let customImageWidth = 90;
  return (
    <Box sx={styles.container}>
      <Container maxWidth="xl" sx={styles.containerStyle}>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }} // Delayed start for staggered effect
        >
          <Box sx={{}}>
            <CustomText
              desc={staticText.coreFeatures}
              fontFamily="Epilogue"
              colorvalue={Colors.andaihubTxt}
              style={{ ...styles.coreFeatureTxt }}
              title3
              fontWeight={400}
            />
          </Box>

          <Box
            sx={{
              width: "100%",
              justifyContent: "center",
              justifyItems: "center",
              alignItems: "center",
              display: "flex",
              paddingBottom: {
                xs: 2,    // mobile
                sm: 3,    // tablet
                md: 3,    // small desktop
                lg: 4,    // desktop
                xl: 4     // large screens
              },
            }}
          >
            <Box
              sx={{
                width: {
                  xs: "95%",    // mobile
                  sm: "90%",    // tablet
                  md: "85%",    // small desktop
                  lg: "70%",    // desktop
                  xl: "70%"     // large screens
                },
                justifyContent: "center",
                justifyItems: "center",
                alignItems: "center",
              }}
            >
              <Box sx={styles.coreFeatureBox}>
                {staticText.coreFeaturesArray.map((item, index) => (
                  <Box key={index} sx={styles.coreFeatureSubBox}>
                    <Box
                      key={index}
                      component="img"
                      src={item.image}
                      alt={`Image ${index + 1}`}
                      sx={{
                        width: customImageWidth,
                        objectFit: "cover",
                      }}
                    />
                    <Box sx={styles.coreSecondBox}>
                      <CustomText
                        desc={item.head}
                        fontFamily="Epilogue"
                        colorvalue={Colors.coreFeatureHeadText}
                        style={{ ...styles.headText, fontSize: {
                          xs: '16px',    // mobile
                          sm: '18px',    // tablet
                          md: '20px',    // small desktop
                          lg: '22px',    // desktop
                          xl: '22px'     // large screens
                        }}}
                        h4
                        fontWeight={400}
                      />
                      <CustomText
                        desc={item.desc}
                        fontFamily="Inter"
                        colorvalue={Colors.textColor}
                        style={{ ...styles.descText, fontSize: {
                          xs: '13px',    // mobile
                          sm: '15px',    // tablet
                          md: '16px',    // small desktop
                          lg: '16px',    // desktop
                          xl: '16px'     // large screens
                        }}}
                        h5
                        fontWeight={400}
                      />
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
}
const styles = {
  headText: {
    lineHeight: 1.4,
    fontStyle: "initial",
    marginBottom: 1,
    wordBreak: "break-word",
  },
  descText: {
    lineHeight: 1.5,
    fontStyle: "initial",
    wordBreak: "break-word",
  },
  coreFeatureSubBox: {
    height: "auto",
    minHeight: {
      xs: 280,    // mobile
      sm: 300,    // tablet
      md: 320,    // small desktop
      lg: 320,    // desktop
      xl: 320     // large screens
    },
    width: "100%",
    maxWidth: {
      xs: 360,    // mobile
      sm: 380,    // tablet
      md: 400,    // small desktop
      lg: 420,    // desktop
      xl: 420     // large screens
    },
    objectFit: "cover",
    borderRadius: 4,
    display: "flex",
    borderColor: Colors.compareFeatureLight,
    borderWidth: 1.5,
    justifyContent: "center",
    alignItems: "center",
    padding: {
      xs: "16px",    // mobile
      sm: "18px",    // tablet
      md: "20px",    // small desktop
      lg: "24px",    // desktop
      xl: "24px"     // large screens
    },
    overflow: "hidden",
    gap: 2,
  },
  coreSecondBox: {
    display: "grid",
    flexDirection: "column",
    marginLeft: {
      xs: 0,    // mobile
      sm: 2,      // tablet
      md: 2.5,    // small desktop
      lg: 3,      // desktop
      xl: 3       // large screens
    },
    overflow: "hidden",
    wordWrap: "break-word",
    flex: 1,
    maxWidth: "calc(100% - 110px)",
  },
  coreFeatureBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    gap: {
      xs: 1.5,    // mobile
      sm: 2,      // tablet
      md: 2.5,    // small desktop
      lg: 3,      // desktop
      xl: 3       // large screens
    },
    flexWrap: "wrap",
    width: "100%",
  },
  container: {
    backgroundColor: Colors.white,
    paddingTop: {
      xs: 3,    // mobile
      sm: 4,    // tablet
      md: 5,    // small desktop
      lg: 6,    // desktop
      xl: 6     // large screens
    },
  },

  containerStyle: {
    backgroundColor: Colors.white,
  },
  coreFeatureTxt: {
    lineHeight: 1,
    fontStyle: "initial",
    textTransform: "none",
    textAlign: "center",
    backgroundColor: Colors.white,
    paddingBottom: {
      xs: 2,    // mobile
      sm: 3,    // tablet
      md: 3,    // small desktop
      lg: 4,    // desktop
      xl: 4     // large screens
    },
    fontSize: {
      xs: '20px',    // mobile
      sm: '20px',    // tablet
      md: '22px',    // small desktop
      lg: '24px',    // desktop
      xl: '24px'     // large screens
    }

  },
};

export default CoreFeatures;
